import React from 'react';
import PropTypes from 'prop-types';

import { NameHead, AccountDetail, Count, Text, TextCount } from './styles';
import { formatAmount, nameFormatter } from '../../../../../utils/commonUtil';

const AccountSummaryMobile = ({ userData }) => (
  <>
    <div data-test='faUserDetailsMobileBlock'>
      <NameHead>
        {`Welcome, ${nameFormatter(
          userData.faFirstName,
          userData.faMiddleName,
          userData.faLastName,
          userData.faSuffix
        )}`}
      </NameHead>
      <AccountDetail data-test='faUserDetailCompany'>
        {userData.company ? userData.company : null}
      </AccountDetail>
      <TextCount>
        <Count primary>{userData.noOfManAccts}</Count>
        <Text>Managed Accounts</Text>
      </TextCount>
      <TextCount primary>
        <Count>{`${formatAmount(userData.totalAssets)}`}</Count>
        <Text>Assets under management</Text>
      </TextCount>
    </div>
  </>
);

export default AccountSummaryMobile;

AccountSummaryMobile.propTypes = {
  userData: PropTypes.shape({
    faFirstName: PropTypes.string.isRequired,
    faMiddleName: PropTypes.string.isRequired,
    faLastName: PropTypes.string.isRequired,
    faSuffix: PropTypes.string.isRequired,
    company: PropTypes.string,
    noOfManAccts: PropTypes.number,
    totalAssets: PropTypes.number,
  }),
};
